import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { BotErrorListStore } from "../../store/BotErrorListStore";

type BotErrorListDialogsProps = {
  store: BotErrorListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de BotError.
 * Separado para mantener BotErrorListPage más limpio.
 */
export const BotErrorListDialogs: React.FC<BotErrorListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  }
);
